import * as React from 'react'
import { Site } from '@envato/foundation-types'

import ExperimentsLoadingCover from '../experimentsLoadingCover'
import experimentsConfig from '../../../config/experiments'

import * as styles from './index.module.css'

interface IProps {
  children: React.ReactNode
  experimentsReady: boolean
  currentSite: Site
}

const SearchPageContentWrapper = ({
  children,
  experimentsReady,
  currentSite
}: IProps) => {
  return (
    <div
      className={styles.contentSection}
      role="main"
      data-test-selector="searchPage"
    >
      <ExperimentsLoadingCover
        experimentsReady={experimentsReady}
        experimentsConfig={experimentsConfig}
        currentSite={currentSite}
      >
        {children}
      </ExperimentsLoadingCover>
    </div>
  )
}

export default SearchPageContentWrapper
